import { Redirect, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { AuthContainer, VerifyOtp, useAuthRouteBase } from '@fhs/auth';

export default function VerifyOtpPage() {
  const { paths } = useAuthRouteBase();
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href={paths.signIn} />;
  }
  return (
    <>
      <Head>
        <title>Verify - Firehouse Subs</title>
      </Head>
      <AuthContainer>
        <VerifyOtp />
      </AuthContainer>
    </>
  );
}
